function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogocomC731Fa8B72B446DbBa02D74A6F092470(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    clipRule: "evenodd",
    fillRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 4986.22 5552.56",
    style: {
      fill: "rgb(0, 0, 0)"
    },
    original_string_length: 856,
    width: "4986px",
    height: "5553px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3275.43 4122.56c969.35,-174.48 1710.79,-1027.36 1710.79,-2045 0,-1142.64 -934.86,-2077.56 -2077.56,-2077.56l-2908.66 0 831.05 831.05 2077.61 0c685.63,0 1246.5,560.95 1246.5,1246.57 0,685.6 -560.87,1246.55 -1246.5,1246.55l-415.49 0 0 1268.76 831.05 -479.79c-16.17,3.34 -32.42,6.46 -48.79,9.42z",
    style: {
      fill: "rgb(84, 84, 84)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1662.11 4155.16c0,-553.97 0,-1108 0,-1662.04l1246.49 0c228.6,0 415.56,-186.92 415.56,-415.49 0,-228.58 -186.96,-415.5 -415.56,-415.5l-2077.55 0c0,830.99 0,1662.04 0,2493.03l0 1397.4 831.05 -479.79 0 -917.61z",
    style: {
      fill: "rgb(94, 217, 87)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogocomC731Fa8B72B446DbBa02D74A6F092470);
export default __webpack_public_path__ + "static/media/logo.com_c731fa8b-72b4-46db-ba02-d74a6f092470.a8173358cca2fcfadf6ae9bd7e08b1a4.svg";
export { ForwardRef as ReactComponent };